export const tierConfig = {
    tier: "Payment Withdraw Tier Config",
    playerTier: "Player Tier",
    tierConfig: "Payment Withdraw Tier Config",
    name: "Name",
    addNewTier: "Add New Tier",
    createNewTierConfig: "Create Tier Config",
    minAmount: "Min Amount",
    maxAmount: "Max Amount",
    rewardAmount: "Reward Amount",
    rewardType: "Reward Type",
    isActive: "Is Active",
    activate: "Activate",
    activated: "Activated",
    startDate: "Start Date",
    endDate: "End Date",
    duration: "Duration",
    activationStatus:'Activation Status',
    updateTierConfig:'Update',
    cancel:'Cancel',
    paymentName:'Payment Name',
    action:'Action',
    deleteTierConfig:'Delete',
    createTierConfig:'Create',
    feeAmount:'Fee Amount',

  };
  